"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float tR;\nuniform vec2 res;\nfloat r;\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  uv = .5+.5*_p*vec2(max(r/tR,1.),max(tR/r,1.));\n}\n    "], ["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float tR;\nuniform vec2 res;\nfloat r;\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  uv = .5+.5*_p*vec2(max(r/tR,1.),max(tR/r,1.));\n}\n    "]),
    _templateObject2 = _taggedTemplateLiteral(["\nprecision highp float;\nvarying vec2 uv;\nuniform sampler2D t;\nvoid main () {\n  gl_FragColor =\n    step(0.0, uv.x) *\n    step(0.0, uv.y) *\n    step(uv.x, 1.0) *\n    step(uv.y, 1.0) *\n    texture2D(t, uv);\n}\n    "], ["\nprecision highp float;\nvarying vec2 uv;\nuniform sampler2D t;\nvoid main () {\n  gl_FragColor =\n    step(0.0, uv.x) *\n    step(0.0, uv.y) *\n    step(uv.x, 1.0) *\n    step(uv.y, 1.0) *\n    texture2D(t, uv);\n}\n    "]),
    _templateObject3 = _taggedTemplateLiteral(["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float zoom;\nuniform vec2 center;\nuniform float tR;\nuniform vec2 res;\nfloat r;\nvec2 invert (vec2 p) {\n  return vec2(p.x, 1.0-p.y);\n}\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  // crop with zoom & center in a cover mode. preserving image ratio\n  float maxR = max(r, tR);\n  vec2 zoomedCanvasSize = vec2(\n    (r / maxR) * zoom,\n    (tR / maxR) * zoom\n  );\n  vec4 crop = vec4(\n    center.x - zoomedCanvasSize.x / 2.,\n    center.y - zoomedCanvasSize.y / 2.,\n    zoomedCanvasSize.x,\n    zoomedCanvasSize.y\n  );\n  // apply the crop rectangle\n  uv = invert(invert(.5+.5*_p) * crop.zw + crop.xy);\n}\n    "], ["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float zoom;\nuniform vec2 center;\nuniform float tR;\nuniform vec2 res;\nfloat r;\nvec2 invert (vec2 p) {\n  return vec2(p.x, 1.0-p.y);\n}\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  // crop with zoom & center in a cover mode. preserving image ratio\n  float maxR = max(r, tR);\n  vec2 zoomedCanvasSize = vec2(\n    (r / maxR) * zoom,\n    (tR / maxR) * zoom\n  );\n  vec4 crop = vec4(\n    center.x - zoomedCanvasSize.x / 2.,\n    center.y - zoomedCanvasSize.y / 2.,\n    zoomedCanvasSize.x,\n    zoomedCanvasSize.y\n  );\n  // apply the crop rectangle\n  uv = invert(invert(.5+.5*_p) * crop.zw + crop.xy);\n}\n    "]),
    _templateObject4 = _taggedTemplateLiteral(["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float zoom;\nuniform vec2 center;\nuniform float tR;\nuniform vec2 res;\nfloat r;\n\nvec2 invert (vec2 p) {\n  return vec2(p.x, 1.0-p.y);\n}\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  // crop with zoom & center in a cover mode. preserving image ratio\n  float maxR = max(r, tR);\n  vec2 zoomedCanvasSize = vec2(\n    (r / maxR) * zoom,\n    (tR / maxR) * zoom\n  );\n  vec4 crop = vec4(\n    center.x - zoomedCanvasSize.x / 2.,\n    center.y - zoomedCanvasSize.y / 2.,\n    zoomedCanvasSize.x,\n    zoomedCanvasSize.y\n  );\n  // clamp to not escape the edges\n  float w = crop[2], h = crop[3];\n  float ratio = w / h;\n  if (w > 1.) {\n    w = 1.;\n    h = w / ratio;\n  }\n  if (h > 1.) {\n    h = 1.;\n    w = h * ratio;\n  }\n  crop = vec4(\n    max(0., min(crop.x, 1.-w)),\n    max(0., min(crop.y, 1.-h)),\n    w,\n    h\n  );\n  // apply the crop rectangle\n  uv = invert(invert(.5+.5*_p) * crop.zw + crop.xy);\n}\n    "], ["\nattribute vec2 _p;\nvarying vec2 uv;\nuniform float zoom;\nuniform vec2 center;\nuniform float tR;\nuniform vec2 res;\nfloat r;\n\nvec2 invert (vec2 p) {\n  return vec2(p.x, 1.0-p.y);\n}\nvoid main() {\n  r = res.x / res.y;\n  gl_Position = vec4(_p,0.0,1.0);\n  // crop with zoom & center in a cover mode. preserving image ratio\n  float maxR = max(r, tR);\n  vec2 zoomedCanvasSize = vec2(\n    (r / maxR) * zoom,\n    (tR / maxR) * zoom\n  );\n  vec4 crop = vec4(\n    center.x - zoomedCanvasSize.x / 2.,\n    center.y - zoomedCanvasSize.y / 2.,\n    zoomedCanvasSize.x,\n    zoomedCanvasSize.y\n  );\n  // clamp to not escape the edges\n  float w = crop[2], h = crop[3];\n  float ratio = w / h;\n  if (w > 1.) {\n    w = 1.;\n    h = w / ratio;\n  }\n  if (h > 1.) {\n    h = 1.;\n    w = h * ratio;\n  }\n  crop = vec4(\n    max(0., min(crop.x, 1.-w)),\n    max(0., min(crop.y, 1.-h)),\n    w,\n    h\n  );\n  // apply the crop rectangle\n  uv = invert(invert(.5+.5*_p) * crop.zw + crop.xy);\n}\n    "]),
    _templateObject5 = _taggedTemplateLiteral(["\nprecision highp float;\nvarying vec2 uv;\nuniform sampler2D t;\nvoid main () {\n  gl_FragColor = texture2D(t, uv);\n}\n    "], ["\nprecision highp float;\nvarying vec2 uv;\nuniform sampler2D t;\nvoid main () {\n  gl_FragColor = texture2D(t, uv);\n}\n    "]);

var _glReact = require("gl-react");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var shaders = _glReact.Shaders.create({
  contain: {
    vert: (0, _glReact.GLSL)(_templateObject),
    frag: (0, _glReact.GLSL)(_templateObject2)
  },
  free: {
    vert: (0, _glReact.GLSL)(_templateObject3),
    frag: (0, _glReact.GLSL)(_templateObject2)
  },
  cover: {
    // NB the cover vertex code can probably be simplified. good enough for now.
    vert: (0, _glReact.GLSL)(_templateObject4),
    frag: (0, _glReact.GLSL)(_templateObject5)
  }
});

var GLImage = function (_Component) {
  _inherits(GLImage, _Component);

  function GLImage() {
    _classCallCheck(this, GLImage);

    return _possibleConstructorReturn(this, (GLImage.__proto__ || Object.getPrototypeOf(GLImage)).apply(this, arguments));
  }

  _createClass(GLImage, [{
    key: "render",
    value: function render() {
      var props = this.props;

      var source = props.source,
          resizeMode = props.resizeMode,
          rest = _objectWithoutProperties(props, ["source", "resizeMode"]);

      if (resizeMode === "cover" || resizeMode === "free") {
        var _center = props.center || [0.5, 0.5];
        var _zoom = props.zoom || 1;
        delete rest.center;
        delete rest.zoom;
        return _react2.default.createElement(_glReact.Node, _extends({}, rest, {
          shader: resizeMode === "cover" ? shaders.cover : shaders.free,
          uniforms: {
            t: source,
            tR: _glReact.Uniform.textureSizeRatio(source),
            res: _glReact.Uniform.Resolution,
            center: _center,
            zoom: _zoom
          }
        }));
      }

      if (resizeMode === "contain") {
        return _react2.default.createElement(_glReact.Node, _extends({}, rest, {
          shader: shaders.contain,
          uniforms: {
            t: source,
            tR: _glReact.Uniform.textureSizeRatio(source),
            res: _glReact.Uniform.Resolution
          }
        }));
      }

      // fallback on stretch, most basic thing
      return _react2.default.createElement(
        _glReact.LinearCopy,
        rest,
        source
      );
    }
  }]);

  return GLImage;
}(_react.Component);

GLImage.defaultProps = {
  resizeMode: "cover"
};
exports.default = GLImage;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/gl-react-image/lib/index.js
// module id = 934
// module chunks = 0